import Reflux from 'reflux';

const SystemJobsActions = Reflux.createActions({
  list: { asyncResult: true },
  getJob: { asyncResult: true },
  cancelJob: { asyncResult: true },
});

export default SystemJobsActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/actions/systemjobs/SystemJobsActions.jsx